import PoiConfirmWithExampleFormContainer from './poi-confirm-with-example-form-container';

export default PoiConfirmWithExampleFormContainer;
